import React from 'react';

const HeroBackground = ({ variant = 'home' }) => {
  const symbols = ['< >', '{ }', '( )', '=>', '#', '::', '[ ]', '++', '--', '&&', '||', '!='];
  
  // Pre-configured positions for a balanced "random" look without using JS random at runtime
  const symbolConfigs = [
    { top: '15%', left: '10%', duration: '18s', delay: '0s', driftX: '30px', driftY: '-20px' },
    { top: '25%', left: '85%', duration: '22s', delay: '2s', driftX: '-40px', driftY: '-50px' },
    { top: '65%', left: '15%', duration: '20s', delay: '4s', driftX: '20px', driftY: '-60px' },
    { top: '75%', left: '75%', duration: '25s', delay: '1s', driftX: '-30px', driftY: '-30px' },
    { top: '40%', left: '20%', duration: '19s', delay: '3s', driftX: '45px', driftY: '-25px' },
    { top: '50%', left: '80%', duration: '21s', delay: '5s', driftX: '-25px', driftY: '-45px' },
    { top: '10%', left: '60%', duration: '24s', delay: '0.5s', driftX: '15px', driftY: '-35px' },
    { top: '85%', left: '45%', duration: '23s', delay: '2.5s', driftX: '-35px', driftY: '-55px' },
  ];

  const variants = {
    home: { glow: 'rgba(0, 230, 118, 0.08)', orbs: ['green', 'amber'] },
    bootcamp: { glow: 'rgba(245, 158, 11, 0.1)', orbs: ['amber', 'amber'] },
    simulator: { glow: 'rgba(0, 230, 118, 0.15)', orbs: ['green', 'green'] },
    interview: { glow: 'rgba(245, 158, 11, 0.12)', orbs: ['amber', 'green'], warmer: true },
    tutorials: { glow: 'rgba(0, 230, 118, 0.06)', orbs: ['green', 'green'] },
    contact: { glow: 'transparent', orbs: ['green', 'amber'], minimal: true },
  };

  const config = variants[variant] || variants.home;

  return (
    <div 
      className="hero-bg-wrapper bg-background" 
      style={{ 
        '--glow-color': config.glow
      }}
    >
      <div className="hero-bg-dot-grid" />
      <div className="hero-bg-glow" />
      
      {!config.minimal && <div className="hero-large-grid" />}

      {/* Diagonal Lines */}
      {!config.minimal && [1, 2, 3, 4].map((i) => (
        <div 
          key={`line-${i}`} 
          className="hero-diagonal-line" 
          style={{ top: `${i * 20}%`, animationDelay: `${i * 3}s` }} 
        />
      ))}

      {/* Ambient Orbs */}
      <div 
        className={`hero-orb hero-orb-${config.orbs[0]}`} 
        style={{ top: '10%', right: '15%', width: '400px', height: '400px' }} 
      />
      <div 
        className={`hero-orb hero-orb-${config.orbs[1]}`} 
        style={{ bottom: '10%', left: '10%', width: '500px', height: '500px', animationDelay: '-5s' }} 
      />

      {/* Floating Symbols */}
      {!config.minimal && symbolConfigs.map((cfg, i) => (
        <div
          key={`symbol-${i}`}
          className="hero-symbol"
          style={{
            top: cfg.top,
            left: cfg.left,
            '--duration': cfg.duration,
            '--delay': cfg.delay,
            '--drift-x': cfg.driftX,
            '--drift-y': cfg.driftY,
            color: variant === 'bootcamp' || variant === 'interview' ? 'var(--accent)' : 'var(--primary)',
            opacity: variant === 'bootcamp' || variant === 'interview' ? 0.04 : 0.06
          }}
        >
          {symbols[i % symbols.length]}
        </div>
      ))}
    </div>
  );
};

export default HeroBackground;
